// extracted by mini-css-extract-plugin
module.exports = {"categoryLabel":"categoryLabel-module--category-label--28f4i"};